import React, { useEffect, useState } from 'react'
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Offcanvas } from 'reactstrap'
import { isValidURL } from 'utils/helpers'

export interface CTA {
    text: string,
    url?: string
}


export interface CTAToBeEditedInterface {
    index: number,
    data: {
        text: string,
        url?: string
    }
}

interface AddCTAProps {
    isOpen: boolean,
    onClose: () => void,
    onAddition: (cta: CTA) => void,
    existingCTA: CTAToBeEditedInterface | null,
    onUpdate: (existingCTA: CTAToBeEditedInterface) => void
}

const AddCTA: React.FC<AddCTAProps> = ({isOpen, onClose, onAddition, existingCTA, onUpdate}) => {

    const [cta, setCTA] = useState<CTA>({text: '', url: ''})
    const [errors, setErrors] = useState<Record<string, string>>({}); 

    useEffect(() => {
        if(isOpen){
            if(existingCTA){
                setCTA(existingCTA.data);
            }else {
                setCTA({text: '', url: ''});
            }
        }
    }, [isOpen, existingCTA])

    const handleSubmit = () => {
        setErrors({});
        const validation_errors: any = {};
        if(!cta.text) validation_errors.text = "Text field is required";
        if(cta.url && !isValidURL(cta.url)) validation_errors.url = "Please enter a valid URL."
        console.log(isValidURL(cta.url!))
        setErrors(validation_errors);
        if(Object.values(validation_errors).length > 0) return;

        if(existingCTA){
            onUpdate({index: existingCTA.index, data: cta})
        }else{
            onAddition(cta);
        }
    }

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
        <ModalHeader className='border-bottom py-3'>
            <span className='fw-bold'>{existingCTA ? 'Update' : 'Add'} CTA</span>
        </ModalHeader>
        <ModalBody>
            <FormGroup>
                <Label>Text <span className="text-danger"> *</span></Label>
                <Input 
                    type='text'
                    value={cta.text}
                    onChange={(e) => setCTA({...cta, text: e.target.value})}
                />
                {
                    errors.text &&
                    <span className="text-danger">{errors.text}</span>
                }
            </FormGroup>
            <FormGroup>
                <Label>URL</Label>
                <Input 
                    type='url'
                    value={cta.url}
                    onChange={(e) => setCTA({...cta, url: e.target.value})}
                />
                {
                    errors.url &&
                    <span className="text-danger">{errors.url}</span>
                }
            </FormGroup>
        </ModalBody>
        <ModalFooter className='border-top py-2'>
            <div className="d-flex justify-content-end align-items-center gap-2">
                <button className='theme-btn theme-btn-lg btn-gradient' onClick={() => handleSubmit()}>{existingCTA ? 'Update' : 'Add'}</button>
            </div>
        </ModalFooter>
    </Modal>
  )
}

export default AddCTA